import Axios from 'axios';
import { User } from './userApi';

export enum JobReportStatusType {
  QUEUED = 'QUEUED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum ReportDocumentType {
  PDF = 'PDF',
  DOCX = 'DOCX',
  EXCEL = 'EXCEL',
}
export interface JobReportsResponse {
  createdByUser: User;
  id: string;
  jobId: string;
  organizationId: number;
  reportName: string;
  reportVersion?: number;
  isFailed?: boolean;
  createdOn: string;
  updatedOn: string;
  gcsPath?: string;
  fileByteSize?: number;
  generatedOn?: string;
  jobReportStatus: JobReportStatusType;
  reportDocumentType?: ReportDocumentType;
}

export enum CUSTOM_REPORTS_DYNAMIC_CONTENT_TYPES {
  ROOM_BASED_REPORT = 'ROOM_BASED_REPORT',
  INSPECTION_BASED_REPORT = 'INSPECTION_BASED_REPORT',
}

export enum CUSTOM_REPORTS_INSPECTION_SELECTION_OPTIONS {
  ALL_INSPECTIONS = 'ALL_INSPECTIONS',
  INITIAL_ATTENDANCE_ONLY = 'INITIAL_ATTENDANCE_ONLY',
  SINGLE_INSPECTION = 'SINGLE_INSPECTION',
  SELECTED_INSPECTIONS = 'SELECTED_INSPECTIONS',
  NO_INSPECTION_SELECTION = 'NO_INSPECTION_SELECTION',
}
export interface CustomJobReportTemplateConfig {
  dynamicContentType: CUSTOM_REPORTS_DYNAMIC_CONTENT_TYPES;
  inspectionSelectionOption: CUSTOM_REPORTS_INSPECTION_SELECTION_OPTIONS;
  photoNotesCountPerRow: number;
}

export interface CustomJobReportTemplate {
  id: string;
  organizationId: number;
  reportName: string;
  templateConfig: CustomJobReportTemplateConfig;
}

export interface CustomJobReport {
  id: string;
  jobId: string;
  organizationId: number;
  reportName: string;
  updatedOn: string;
  createdByUserId: string;
  createdByUser: User;
  createdOn: string;
  isFailed?: boolean;
  gcsPath?: string;
  fileByteSize?: number;
  generatedOn?: string;
  jobReportStatus: JobReportStatusType;
}

export enum JobReportType {
  Attendance_Report = 'InitialAttendanceReport',
  Completion_Report = 'CompletionReport',
  Inventory_Detail_Report = 'InventoryDetailReport',
  Inventory_Photo_Report = 'InventoryPhotoReport',
  Photo_Report = 'PhotoReport',
  Site_Visit_Report = 'SiteVisitReport',
}

export enum JobDocumentsType {
  // Uploads = 'Uploads',
  Reports = 'Reports',
  // Forms = 'Forms',
  // Estimates = 'Estimates',
  // Invoice = 'Invoices',
}


export enum JobFileDownloadType {
  PHOTO_NOTES_DOWNLOAD = 'PHOTO_NOTES_DOWNLOAD',
  ATTENDANCE_REPORT_DOWNLOAD = 'ATTENDANCE_REPORT_DOWNLOAD',
  COMPLETION_REPORT_DOWNLOAD = 'COMPLETION_REPORT_DOWNLOAD',
  INVENTORY_REPORT_DOWNLOAD = 'INVENTORY_REPORT_DOWNLOAD',
  SITE_VISIT_REPORT_DOWNLOAD = 'SITE_VISIT_REPORT_DOWNLOAD',
}

export async function listCustomReportTemplates() {
  const res = await Axios.get('/api/v1/custom-job-reports/templates');
  return res.data || [];
}

export async function listJobReports(
  jobId: string,
  refetchRef: React.MutableRefObject<{
    refetchCount: number;
    isQueryInitialized: boolean;
  }>
) {
  const res = await Axios.get(`/api/v1/job-reports/${jobId}`);
  refetchRef.current.refetchCount++;
  return res.data;
}

export async function downloadJobReport(jobId: string, id: string) {
  const res = await Axios.get(`/api/v1/job-reports/${jobId}/${id}`);
  return res.data;
}

export async function deleteJobReport({
  jobId,
  id,
}: {
  jobId: string;
  id: string;
}) {
  const res = await Axios.delete(`/api/v1/job-reports/${jobId}/${id}`);
  return res.data;
}

export async function listCustomJobReports(
  jobId: string,
  refetchRef: React.MutableRefObject<{
    refetchCount: number;
    isQueryInitialized: boolean;
  }>
) {
  const res = await Axios.get(`/api/v1/custom-job-reports/${jobId}`);
  refetchRef.current.refetchCount++;
  return res.data;
}

export async function generateCustomJobReport({
  jobId,
  customTemplateId,
  letterheadId,
  inspectionIds,
}: {
  jobId: string;
  customTemplateId: string;
  letterheadId?: string;
  inspectionIds?: string[];
}): Promise<void> {
  const params = new URLSearchParams(`letterheadId=${letterheadId}`);
  if (inspectionIds && inspectionIds.length > 0) {
    params.set('inspectionIds', inspectionIds.join(','));
  }
  const searchParams = params.toString();

  const res = await Axios.get(
    `/api/v1/custom-job-reports/${jobId}/${customTemplateId}/generate/${`?${searchParams}`}`
  );
  return res.data;
}

export async function deleteCustomJobReport({
  jobId,
  id,
}: {
  jobId: string;
  id: string;
}) {
  const res = await Axios.delete(`/api/v1/custom-job-reports/${jobId}/${id}`);
  return res.data;
}

export async function downloadCustomJobReport(jobId: string, id: string) {
  const res = await Axios.get(`/api/v1/custom-job-reports/${jobId}/${id}`);
  return res.data;
}
